import { render, staticRenderFns } from "./SfProperty.vue?vue&type=template&id=3978c43e&functional=true"
import script from "./SfProperty.vue?vue&type=script&lang=js"
export * from "./SfProperty.vue?vue&type=script&lang=js"
import style0 from "./SfProperty.vue?vue&type=style&index=0&id=3978c43e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports